/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Portfolio Verwaltung
 *
 * Hier wird das Portfilio als Periodensystem angezeigt. 
 * 
 * Aus der obersten Ebene des Verzeichnisses wird das Hauptverzeichnis
 * erstellt. Das Hauptverzeichnis wird als Periodensystem dargestellt.
 * Der Benutzer hat die Möglichkeit das Layout des Periodensystems 
 * nach seinen Bedürfnissen anzupassen. Um das Layout ändern zu können,
 * wurde eine Gridsystem mit Kacheln implementiert. Die Kacheln können
 * im Gridsystem beliebig positioniert werden. Ebenso können die Kacheln
 * auch vergrößert oder verkleinert werden.
 * 
 */
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactGridLayout from 'react-grid-layout';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import { Icon } from '../../partials/Icons';
import * as utils from "../../../basics/utils";
import * as cordova from "../../../basics/cordova";
import * as appActions from "../../../store/actions/appActions";
import * as portfolioActions from '../../../store/actions/portfolioActions';
import defaultBackground from 'assets/images/defaultBackground.jpg';

//import Particles from 'react-tsparticles';

class Portfolio extends React.Component {
    constructor(props) {
        super(props);

        this.versionSubDirs = 'hidden'; // alternative 'hidden' | 'scroll'
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { toolbarType, windowWidth, inputHeight, unitHeight, gridEdit, gridEditType, path, orientation, appModus, currentContainer } = this.props.app;
        const { portfolioList } = this.props.portfolio;
        const { syncType } = this.props.sync;
        const { loginUser } = this.props.user;

        const frameSize = windowWidth * .03;

        //const borderWidth = Math.min((windowWidth / 100 * .5), iPhone ? 2 : 3);
        const borderWidth = 0;

        const dialog = utils.getDialogByPath(path);

        const fontFactor = windowWidth / 100 * (orientation === 'landscape' ? 1.3 : 1.7);

        const classButton = "w-1/10 px-8 inline-block rounded text-center justify-center items-center font-semibold mx-2 text-white";

        //const styleButton = { backgroundColor: 'rgb(58, 133, 247)', ...utils.getStyleHeight(unitHeight, .5, .5, .3) };

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderIcon = (type) => {
            return (
                <div style={utils.getStyleHeight(unitHeight, .6, .6, .6)} >
                    <Icon type={type} width={unitHeight * .5} height={unitHeight * .5} color='white' />
                </div>
            )
        }

        const renderEditButton = () => {
            const onClick = () => { this.props.setGridEdit(!gridEdit) }

            /**
             * Keine CustomLayout-Funktion für Admin.
             * Layoutanpassungen werden nur dann berücksichtigt, wenn der Benutzer die Rolle 'User' besitz.
             * Ist der Benutzer Administrator, so werden keinerlei Layoutanpassungen geladen, da dies sonst
             * zu verwirrend sein kann.
             * Mit der nachfolgenden Abfrage wird verhindert, dass der Administrator im Preview-Mode
             * Layoutanpassungen machen kann.  
             */
            //if (loginUser && loginUser.role === 'Admin' && appPreview) return null;

            if (!gridEdit) {
                return (<div className={classButton} onClick={onClick}>{renderIcon('settings')}</div>);
            }
        }

        const renderAddButton = () => {
            return null;
            /* Funktion wurde in Footer verlagert
            const onClick = () => { this.props.setModalDialog('PortfolioModal', 'create') }

            if (!gridEdit) return null;

            if (appModus !== 'Admin') return null;

            return (
                <div className={classButton} onClick={onClick} style={styleButton}><AddIcon />Neu</div>
            )
            */
        }

        // ###############################################################
        // renderItem / Darestellung einer einzelnen Kachel
        // ###############################################################
        const renderItem = (portfolio, height) => {
            let layout = portfolio;

            let subDirList = [];
            let textSumProducts = '';

            if (appModus === 'User') {
                /**
                 * Keine CustomLayout-Funktion für Admin.
                 * Layoutanpassungen werden nur dann berücksichtigt, wenn der Benutzer die Rolle 'User' besitz.
                 * Ist der Benutzer Administrator, so werden keinerlei Layoutanpassungen geladen, da dies sonst
                 * zu verwirrend sein kann.
                 * Mit der nachfolgenden Abfrage wird verhindert, dass der Administrator im Preview-Mode
                 * Layoutanpassungen machen kann.  
                 */
                if (!(loginUser && loginUser.role === 'Admin')) {
                    const customLayout = utils.getCustomLayoutTile(portfolio);
                    if (customLayout !== null) {
                        layout.rowSpan = customLayout.h;
                        layout.colSpan = customLayout.w;
                        layout.row = customLayout.y;
                        layout.col = customLayout.x;
                    }
                }

                const maxItemsInTile = (layout.rowSpan === 1) ? 4 : layout.rowSpan * 4;

                if (orientation === 'landscape' && layout.colSpan > 1) {
                    if (portfolio['children']) {
                        subDirList = portfolio.children.filter((d) => d.type === 'directory');

                        if (subDirList.length > maxItemsInTile && this.versionSubDirs === 'hidden') {
                            subDirList = [];
                        }
                    }
                    if (subDirList.length === 1) textSumProducts = subDirList.length + ' Gruppe';
                    if (subDirList.length > 1) textSumProducts = subDirList.length + ' Gruppen';
                }
            }

            const className = (gridEdit) ? " border-dashed" : "";

            const onClick = (e) => {
                if (gridEdit) return;

                if (appModus === 'Admin') {
                    const isAlt = (e.altKey && !e.shiftKey && !e.ctrlKey);
                    if (isAlt) {
                        this.props.setModalDialog('DebugModal', '');
                        return;
                    }
                    this.props.scanPortfolio(portfolio.name, null, null, portfolio.name);
                } else {
                    this.props.setPath(portfolio.name);
                    this.props.setCurrentPortfolio(portfolio);
                }
            }

            /**
             * Oberer Bereich der Kachel
             * Hier wird der Titel "LT" angezeigt
             * Ist die Kachel breiter, so werden auch die ersten drei Unterverzeichnisse angezeigt
             */
            const renderUpper = () => {
                const style = { height: '66%', fontSize: '350%' };

                const renderShortTitle = () => {
                    return (<div className="xxx font-bold" style={utils.getStyleHeight(fontFactor, 1, 1, 2.5)}>
                        {gridEdit && !gridEditType && appModus === 'Admin' && <EditIcon onClick={() => onEdit('update')} />}
                        &nbsp;{portfolio.abbr.toUpperCase()}&nbsp;
                        {gridEdit && !gridEditType && appModus === 'Admin' && <DeleteIcon onClick={() => onEdit('delete')} />}
                    </div>
                    )
                }

                /**
                 * Unterverzeichnisse/Produktgruppen in Kachel anzeigen
                 * 
                 * Beispiel LG - Lagertechnik
                 * Die Kachel für Lagertechnik hat folgende Produktgruppen
                 * > Doppelstockgeräte
                 * > Hochhubwagen
                 * > Kommisionieren
                 * > weitere
                 * In der renderSubDirectory-Funktion werden diese Produktgruppen
                 * unter den folgenden Voraussetzungen angezeigt:
                 * 1. Die Kachel ist groß genug
                 * 2. Die Anwendung ist nicht im "Design"-Mode
                 */
                const renderSubDirectory = () => {

                    const renderDirItem = (group, i) => {

                        const onClick = () => {
                            if (gridEdit) return;

                            this.props.setCurrentGroup(group);
                            this.props.setCurrentPortfolio(portfolio);

                            this.props.setPath(portfolio.name + '/' + group.name);
                        }

                        return (
                            <div key={i}>
                                <div className="inline-block flex font-thin whitespace-no-wrap" onClick={onClick}>
                                    <div className="font-thin" style={utils.getStyleHeight(fontFactor, 1, .7, 1.3)}>
                                        &#8250;&nbsp;
                                    </div>
                                    <div className="font-normal" style={utils.getStyleHeight(fontFactor, 1, 1, .7)}>
                                        {group.name}
                                    </div>
                                </div >
                            </div>
                        )
                    }

                    return (
                        <div className="overflow-hidden">
                            {subDirList.map((group, i) => renderDirItem(group, i))}
                        </div>
                    )
                }

                // ###############################################################
                // renderUpper
                // ###############################################################
                const onEdit = (crudType) => {
                    this.props.getPortfolio(portfolio.id, 'PortfolioModal', crudType);
                }

                if (layout.colSpan > 1 && subDirList.length > 0) {
                    return (
                        <div className="flex flex-col w-full font-bold " style={style}>
                            <div className="flex w-full h-full p-2 " >
                                <div className="w-2/5 flex flex-col justify-center text-center " onClick={onClick}>
                                    {renderShortTitle()}
                                </div>
                                <div className={"w-3/5 flex justify-center overflow-hidden " + ((this.versionSubDirs === 'hidden') ? 'items-center' : '')}>
                                    {renderSubDirectory()}
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className="flex flex-col justify-center w-full text-center font-bold" style={style} onClick={onClick}>
                            {renderShortTitle()}
                        </div>
                    )
                }
            }

            /**
             * Unterer Bereich der Kachel
             * Hier wird der Titel "LAGERTECHNIK" angezeigt
             */
            const renderLower = () => {
                const style = {
                    height: height * layout.rowSpan * .3,
                    borderWidth: (borderWidth) + 'px 0 0 0'
                }

                //
                // Ist die Kachel breiter als eine Einheit, so wird rechts neben dem Titel 
                // auch die Anzahl Produkte im Verzeichnis angezeigt
                //
                if (layout.colSpan > 1 && subDirList.length > 0) {

                    return (
                        <div className={"w-full flex flex-col items-center justify-center text-center font-bold border-white" + className} style={style} onClick={onClick}>
                            <div className="flex justify-center w-full px-2" style={utils.getStyleHeight(fontFactor, 1, 1, .7)}>
                                <div className="flex w-2/5 items-center justify-center text-left font-bold ">
                                    {portfolio.name.toUpperCase()}
                                </div>
                                <div className="flex w-3/5 justify-center" >
                                    {textSumProducts}
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    //
                    // Ist die Kachel nur eine Einheit breit, so wird lediglich der Titel angezeigt
                    //
                    return (
                        <div className={"w-full flex flex-col items-center justify-center text-center font-bold border-white p-2" + className} style={style} onClick={onClick}>
                            <div className="flex items-center justify-center w-full px-2" style={utils.getStyleHeight(fontFactor, 1, 1, .7)}>
                                {portfolio.name.toUpperCase()}
                            </div>
                        </div>
                    )
                }
            }

            // ###############################################################
            // renderItem
            // ###############################################################
            const style = { backgroundColor: portfolio.color, borderWidth: (borderWidth) + 'px' };

            return (
                <div key={portfolio.name} className="w-full h-full p-2 cursor-pointer" style={{ backgroundColor: 'transparent' }} data-grid={{ x: layout.col, y: layout.row, w: layout.colSpan, h: layout.rowSpan }}>
                    <div className={"relative w-full h-full rounded-lg overflow-hidden border-white" + className} style={style}>
                        {renderUpper()}
                        {renderLower()}
                    </div>
                </div>
            );
        }

        // ###############################################################
        // renderGrid / Gittersystem mit Kacheln
        // ###############################################################
        const renderGrid = () => {

            if (portfolioList.length === 0) return null;

            let factor = windowWidth / inputHeight;

            let grid = { rows: 4, cols: 6 }
            let gridSize = { width: windowWidth - frameSize * 3, height: inputHeight - frameSize * 3 }

            if (factor < 1.0) {
                gridSize = { width: windowWidth - frameSize * 3, height: (inputHeight - frameSize * 3) * factor }
            }
            const onDragStart = (layout) => {
                //console.log('onDragStart', layout);
            }

            const onLayoutChange = (newLayout) => {
                if (!gridEdit) return;

                if (appModus === 'Admin') {
                    // =============================================================================            
                    // ADMIN-MODE              
                    // =============================================================================            
                    for (let p of portfolioList) {
                        const layoutList = newLayout.filter(l => l.i === p.name)
                        if (layoutList.length > 0) {
                            const l = layoutList[0];
                            if (!(l.x === p.col && l.y === p.row && l.w === p.colSpan && l.h === p.rowSpan)) {

                                let newPortfolio = p;
                                newPortfolio.col = l.x;
                                newPortfolio.row = l.y;
                                newPortfolio.colSpan = l.w;
                                newPortfolio.rowSpan = l.h;

                                this.props.updatePortfolio(newPortfolio.id, newPortfolio)
                            }
                        }
                    }
                } else {
                    // =============================================================================            
                    // USER-MODE              
                    // =============================================================================   
                    this.props.setCustomLayout(newLayout);

                    cordova.writeLocalJSON(currentContainer, 'customLayout.json', newLayout)
                }
            }

            // ###############################################################
            // renderGrid
            // ###############################################################

            const key = gridEdit ? orientation : new Date().getTime();

            const rowHeight = gridSize.height / grid.rows;

            const isDraggable = gridEdit && gridEditType;
            const isResizable = gridEdit && gridEditType;

            return (
                <div key={key} className="w-full h-full react-grid-layout overflow-visible" style={{ marginTop: frameSize, marginLeft: frameSize, width: gridSize.width, height: gridSize.height }}>
                    <ReactGridLayout
                        isDraggable={isDraggable}
                        isResizable={isResizable}
                        onLayoutChange={onLayoutChange}
                        onDragStart={onDragStart}
                        autoSize={true}
                        compactType={null}
                        preventCollision={true}
                        margin={[0, 0]}
                        rowHeight={rowHeight}
                        maxRows={grid.rows}
                        width={gridSize.width}
                        cols={grid.cols}>
                        {portfolioList.map((portfolio) => renderItem(portfolio, rowHeight))}
                    </ReactGridLayout>
                </div>
            )

        }

        // ###############################################################
        // renderEditToolbar / Toolbar ganz unten
        // ###############################################################
        const renderEditToolbar = () => {
            const style = Object.assign({ bottom: unitHeight }, utils.getStyleHeight(unitHeight, 1, 1, 0.8));

            return (
                <div className="EditToolbar absolute w-full flex flex-row-reverse items-center" style={style}>
                    {renderEditButton()}
                    <div className="flex-grow"></div>
                    {renderAddButton()}
                </div>
            )
        }

        // ###############################################################
        // renderParticlesLayer() / Stylisher Hintergrund
        // https://vincentgarreau.com/particles.js/
        // ###############################################################     
        /*
        const renderParticlesLayer = () => {

            return renderDefaultBackground();

            if (loginUser && loginUser.role === 'Admin' && !appPreview) {

                return <div className="absolute top-0 w-full h-full bg-black">
                    <div className="relative w-full h-full">
                    </div>
                </div>
            } else {
                const style = {
                    marginTop: headerHeight,
                    height: inputHeight,
                    maxHeight: inputHeight,
                }

                const particlesParamNew = {
                    particles: {
                        number: {
                            value: 160,
                            density: { enable: true, value_area: 800 }
                        },
                        color: {
                            value: '#ffffff'
                        },
                        shape: {
                            type: 'circle',
                            stroke: { width: 0, color: '#000000' },
                            polygon: { nb_sides: 5 },
                            image: { src: 'img/github.svg', width: 100, height: 100 }
                        },
                        opacity: {
                            value: 1,
                            random: true,
                            anim: { enable: true, speed: 1, opacity_min: 0, sync: false }
                        },
                        size: {
                            value: 1,
                            random: true,
                            anim: { enable: false, speed: 4, size_min: 0.3, sync: false }
                        },
                        line_linked: {
                            enable: false,
                            distance: 150,
                            color: '#ffffff',
                            opacity: 0.4,
                            width: 1
                        },
                        move: {
                            enable: true,
                            speed: 1,
                            direction: 'none',
                            random: true,
                            straight: false,
                            out_mode: 'out',
                            bounce: false,
                            attract: { enable: false, rotateX: 600, rotateY: 600 }
                        }
                    },
                    interactivity: {
                        events: {
                            onhover: { enable: true, mode: 'bubble' },
                            onclick: { enable: true, mode: 'repulse' },
                            resize: true
                        },
                        modes: {
                            grab: { distance: 400, line_linked: { opacity: 1 } },
                            bubble: { distance: 250, size: 0, duration: 2, opacity: 0, speed: 3 },
                            repulse: { distance: 400, duration: 0.4 },
                            push: { particles_nb: 4 },
                            remove: { particles_nb: 2 }
                        }
                    },
                    retina_detect: true
                }

                return (
                    <Particles className="absolute w-full " style={style}
                        params={particlesParamNew}
                    />
                )
            }

        }
        */

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        const style = {
            height: inputHeight,
            minHeight: inputHeight,
            backgroundPosition: 'center center',
            backgroundImage: "url(" + defaultBackground + ")",
        }

        if (syncType !== '') return null;

        if (dialog.dialogType !== 'portfolio') return null;

        if (toolbarType !== 'portfolios') return null;

        return (
            <div className="Portfolio w-full h-full flex" style={style}>
                {renderGrid()}
                {renderEditToolbar()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        sync: state.sync,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
